import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { ConditionalTemplateRunner } from '../../service/data';
import { CTSelectSetting } from '../../../element/service/recordview-param';
import { SelectConditionalValue } from '../../model/model';
import { MatRadioChange } from '@angular/material';

@Component({
	selector: 'common-ct-runner-select',
	templateUrl: './ct-runner-select.component.html',
	styleUrls: ['./ct-runner-select.component.scss']
})
export class CtRunnerSelectComponent implements OnInit {
	@HostBinding('class.ct-runner-select') hostClass = true;
	@Input() data: ConditionalTemplateRunner;
	get setting(): CTSelectSetting {
		if (this.data) {
			return this.data.Setting as CTSelectSetting;
		}
		return undefined;
	}
	getValue() {
		const v = this.data.Data.Value as SelectConditionalValue;
		if (v) {
			return v.Value;
		}
		return undefined;
	}
	setValue(val: MatRadioChange) {
		let mval = this.data.Data.Value as SelectConditionalValue;
		if (!mval) {
			mval = {} as SelectConditionalValue;
			this.data.Data.Value = mval;
		}
		mval.OtherOption = this.setting.OtherOption;
		mval.Options = this.setting.Options.filter(v => v.Value !== this.setting.OtherOption).map(v => v.Value);
		mval.Value = val.value;
		this.data.enable = !!val.value;
	}
	constructor() {}

	ngOnInit() {}
}
